export class InputModel {
  type:string;
  name:Map<string,string>;
  placeholder:Map<string,string>;
  label:Map<string,string>;
  validation:Map<string,string>;
  value:string;

  constructor() {
    this.label = new Map<string, string>();
    this.validation = new Map<string, string>();
    this.name = new Map<string, string>();
    this.placeholder = new Map<string, string>();
  }

}
